/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ref_TitleInputs */

const en_diff_ref_title = /** @type {(inputs: Diff_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading the output`)
};

const ko_diff_ref_title = /** @type {(inputs: Diff_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력 읽는 법`)
};

const ja_diff_ref_title = /** @type {(inputs: Diff_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力の読み方`)
};

/**
* | output |
* | --- |
* | "Reading the output" |
*
* @param {Diff_Ref_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ref_title = /** @type {((inputs?: Diff_Ref_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ref_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ref_title(inputs)
	if (locale === "ko") return ko_diff_ref_title(inputs)
	return ja_diff_ref_title(inputs)
});